import React from "react"
import {
	DispatchProductDetailPageReducer,
	ProductDetailPageReducerState,
	setSelectedOuterLength,
	setSelectedInnerLength,
	setSelectedSystem,
} from "@secureo/common/reducers/productDetailPageReducer"

import SystemAndLengthCombinationConfigurationInput from "components/Configurations/SystemAndLengthCombinationConfigurationInput"

const SystemAndLengthCombinationConfigurations = ({
	isLoading,
	dispatch,
	reducerState,
	accessToken,
}: Props) => {
	const {
		selectedSystem,
		selectedOuterLength,
		selectedInnerLength,
		attributes: { lengthCombinationsBySystem, systemConfigurationToolTip },
	} = reducerState

	const onSystemChange = (selectedSystem: string) => {
		setSelectedSystem(accessToken, dispatch, reducerState, selectedSystem)
	}

	const onOuterLengthChange = (selectedOuterLength: number) => {
		setSelectedOuterLength(accessToken, dispatch, reducerState, selectedOuterLength)
	}

	const onInnerLengthChange = (selectedInnerLength: number) => {
		setSelectedInnerLength(accessToken, dispatch, reducerState, selectedInnerLength)
	}

	return (
		<SystemAndLengthCombinationConfigurationInput
			lengthCombinationsBySystem={lengthCombinationsBySystem}
			selectedSystem={selectedSystem}
			selectedOuterLength={selectedOuterLength}
			selectedInnerLength={selectedInnerLength}
			onSystemChange={onSystemChange}
			onOuterLengthChange={onOuterLengthChange}
			onInnerLengthChange={onInnerLengthChange}
			disabled={isLoading || !accessToken}
			systemConfigurationToolTip={systemConfigurationToolTip}
			showMeasureCylinderDialog
		/>
	)
}

interface Props {
	isLoading: boolean
	dispatch: DispatchProductDetailPageReducer
	reducerState: ProductDetailPageReducerState
	accessToken: string
}

export default SystemAndLengthCombinationConfigurations
